import { Outlet, createFileRoute } from "@tanstack/react-router";

import { EmptyState, Icon } from "@sx/ui";

import { useMe } from "../../../../lib/session";
import { isOperator } from "../../../../lib/operator";
import { RouteFallback } from "../../../../shell/RouteFallback";

export const Route = createFileRoute("/_console/settings/platform")({
  component: OperatorLayout,
});

/* The operator area's gate.
 *
 * The nav items below `/settings/platform` are absent without `(auth, admin)`, but an
 * address is guessable and a bookmark outlives a grant — so the boundary is stated here
 * too, once, rather than being left to four screens each showing a 403 per card.
 *
 * Read off the session the shell already holds: `GET /api/auth/session` answers for the
 * `auth` audience, so the grant the door itself checks is right there. No probe request,
 * and no second definition of what "operator" means. The door remains the enforcement:
 * every read below is refused server-side regardless of what this component decided.
 */
function OperatorLayout() {
  const me = useMe();
  if (!me.data) return <RouteFallback />;

  if (!isOperator(me.data)) {
    return (
      <EmptyState
        icon={<Icon name="not-allowed" />}
        title="Not a platform operator"
        hint="These screens run the platform itself, and you are not allowed in them. Your own account and organization settings are unaffected."
      />
    );
  }

  return <Outlet />;
}
